import React, { FC, useEffect, useRef, useState, useContext } from 'react'
import { isMobile } from 'react-device-detect'
import moment from 'moment'
import firebase from 'firebase/app'
import appContext from '../../../context/appContext'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericRow from '../../../GenericComponents/GenericRow'

import GenericInput from '../../../GenericComponents/GenericInput'
import SendArrow from '../../../assets/REDESIGN_Assets/ChatBox/send-button-arrow.svg'

import {
  ChatBoxViewBox,
  ChatContainer,
  ChatSingleMessage,
  ChatSendButton,
  InputContainer,
} from '../style/ChatBoxStyle'
import AppContext from '../../../context/appContext'

interface ChatBoxViewInterface {
  chatName: string
  messages: any
  user: any
}

const ChatBoxView: FC<ChatBoxViewInterface> = ({
  chatName,
  messages,
  user,
}) => {
  const chatContainerRef: any = useRef()
  const appContext = useContext(AppContext)

  const [userMessage, setUserMessage] = useState('')

  useEffect(() => {
    if (chatContainerRef.current) {
      setTimeout(() => {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight -
          chatContainerRef.current.clientHeight
      }, 700)
    }
  }, [])

  const handleEnterSendMessage = (event: any) => {
    if (event.key === 'Enter') {
      sendMessage()
    }
  }

  const sendMessage = async () => {
    if (!userMessage.length || userMessage == '') {
      alert('Wiadomość nie może być pusta')
      return
    } else {
      const res = await firebase
        .firestore()
        .collection('0e23f94f1435d2e63d39865c407d847f')
        .add({
          author_id: user.id,
          author_name: chatName,
          message: userMessage,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        })
      setUserMessage('')
    }

    // test chat 98C6C14ACCE440C6AB3058D2970D5A0F
    // prod chat 0e23f94f1435d2e63d39865c407d847f
  }

  return (
    <ChatBoxViewBox>
      <GenericTextSpan
        margin={isMobile ? '-5vh 0 3vh 0' : '10vh 0 4vh 0'}
        justify={'center'}
        tAlign={'center'}
        fSize={isMobile ? '2.6rem' : '4rem'}
        className={`${appContext.appState.theme == 'light' ? 'light' : ''}`}
      >
        {chatName}
      </GenericTextSpan>
      <ChatContainer
        ref={chatContainerRef}
        className={'chat-container'}
        id={'chatContainer'}
      >
        {messages.length &&
          messages.map((message: any) => (
            <ChatSingleMessage>
              <GenericRow margin={'0 0 2% 0'} justify={'flex-start'}>
                <GenericTextSpan
                  fWeight={'bold'}
                  fSize={isMobile ? '1.5rem' : '1.15rem'}
                  className={`${
                    appContext.appState.theme == 'light' ? 'light' : ''
                  }`}
                  // display={'flex'}
                  // width={'100%'}
                  // justify={'flex-start'}
                >
                  {message.author_name}
                </GenericTextSpan>
                <GenericTextSpan
                  margin={'0 0  0 5% '}
                  fSize={isMobile ? '1rem' : '0.75rem'}
                  opacity={'0.5'}
                  className={`${
                    appContext.appState.theme == 'light' ? 'light' : ''
                  }`}
                  // display={'flex'}
                  // width={'100%'}
                  // justify={'flex-start'}
                >
                  {message.timestamp &&
                    message.timestamp.seconds &&
                    `${moment(message.timestamp.seconds * 1000).fromNow(
                      true
                    )} temu`}
                </GenericTextSpan>
              </GenericRow>
              <GenericRow>
                <GenericTextSpan
                  display={'flex'}
                  fSize={isMobile ? '1.2rem' : '0.9rem'}
                  width={'100%'}
                  justify={'flex-start'}
                  tAlign={'left'}
                  // lineHeight={'1.41'}
                  className={`${
                    appContext.appState.theme == 'light' ? 'light' : ''
                  }`}
                >
                  {message.message}
                </GenericTextSpan>
              </GenericRow>
            </ChatSingleMessage>
          ))}
      </ChatContainer>
      <InputContainer>
        <GenericInput
          className={`${
            appContext.appState.theme == 'light' ? 'light' : 'color-white'
          }`}
          width={'90%'}
          value={userMessage}
          placeholder="Wpisz wiadomość"
          onChange={(e: any) => setUserMessage(e.target.value)}
          onKeyDown={handleEnterSendMessage}
        ></GenericInput>
        <ChatSendButton onClick={() => sendMessage()}>
          <GenericIcon
            src={SendArrow}
            width={isMobile ? '3.5vw' : '1.2vw'}
            height={isMobile ? '3.5vw' : '1.2vw'}
          ></GenericIcon>
        </ChatSendButton>
      </InputContainer>
    </ChatBoxViewBox>
  )
}

export default ChatBoxView
